exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_productTable__Xi5uT {\n  border-collapse: separate;\n  border-spacing: 5px 0;\n}\n.styles_productWrapper__FqP8b{\n  padding-top: 20px;\n  display: flex;\n  flex-direction: row;\n}\n\n.styles_saveButton__JsfNQ{\n  display: flex;\n  flex-direction: row-reverse;\n  padding-right: 5px;\n  padding-top: 15px;\n}\n", ""]);

// Exports
exports.locals = {
	"productTable": "styles_productTable__Xi5uT",
	"productWrapper": "styles_productWrapper__FqP8b",
	"saveButton": "styles_saveButton__JsfNQ"
};